export const InputStyle = {
  Default: "default",
  ProfileForm: "profileForm",
  WebinarMessage: "webinarMessage",
};
